import { PLACEHOLDER_APP_ICON } from "./constants";

export function getServiceIconUrl(slug: string | null | undefined) {
  if (!slug) {
    return PLACEHOLDER_APP_ICON;
  }
  return `/generated/${slug}/64`;
}
